/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { Milestone } from './Milestone';
import {
    MilestoneFromJSON,
    MilestoneFromJSONTyped,
    MilestoneToJSON,
    instanceOfMilestone,
} from './Milestone';
import type { TaskViewAsset } from './TaskViewAsset';
import {
    TaskViewAssetFromJSON,
    TaskViewAssetFromJSONTyped,
    TaskViewAssetToJSON,
    instanceOfTaskViewAsset,
} from './TaskViewAsset';

/**
 * Details needed to render a task instance inside a Classroom iframe.
 * @export
 * @interface TaskInstanceView
 */
export interface TaskInstanceView {
    /**
     * Display title presented in the iframe.
     * @type {string}
     * @memberof TaskInstanceView
     */
    title: string;
    /**
     * Subtitle shown with the assignment details.
     * @type {string}
     * @memberof TaskInstanceView
     */
    subheading: string;
    /**
     * Instructions for the educator or student.
     * @type {string}
     * @memberof TaskInstanceView
     */
    instructions: string;
    /**
     * Optional assets attached directly to the task.
     * @type {Array<string>}
     * @memberof TaskInstanceView
     */
    assetIds?: Array<string>;
    /**
     * Render-ready metadata for assets referenced by this task and its milestones.
     * @type {Array<TaskViewAsset>}
     * @memberof TaskInstanceView
     */
    assets?: Array<TaskViewAsset>;
    /**
     * Optional milestones that outline partial completion goals.
     * @type {Array<Milestone>}
     * @memberof TaskInstanceView
     */
    milestones?: Array<Milestone>;
    /**
     * Experience display name to show alongside the task.
     * @type {string}
     * @memberof TaskInstanceView
     */
    experienceName: string;
    /**
     * Roblox game ID which informs the play button link
     * @type {string}
     * @memberof TaskInstanceView
     */
    robloxGameId: string;
    /**
     * Optional assets attached to the owning experience.
     * @type {Array<string>}
     * @memberof TaskInstanceView
     */
    experienceAssetIds?: Array<string>;
}


/**
 * Check if a given object implements the TaskInstanceView interface.
 */
export function instanceOfTaskInstanceView(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "subheading" in value;
    isInstance = isInstance && "instructions" in value;
    isInstance = isInstance && "experienceName" in value;
    isInstance = isInstance && "robloxGameId" in value;
    return isInstance;
}

export function TaskInstanceViewFromJSON(json: any): TaskInstanceView {
    return TaskInstanceViewFromJSONTyped(json, false);
}

export function TaskInstanceViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskInstanceView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'title': json['title'],
        'subheading': json['subheading'],
        'instructions': json['instructions'],
        'assetIds': !exists(json, 'assetIds') ? undefined : json['assetIds'],
        'assets': !exists(json, 'assets') ? undefined : ((json['assets'] as Array<any>).map(TaskViewAssetFromJSON)),
        'milestones': !exists(json, 'milestones') ? undefined : ((json['milestones'] as Array<any>).map(MilestoneFromJSON)),
        'experienceName': json['experienceName'],
        'robloxGameId': json['robloxGameId'],
        'experienceAssetIds': !exists(json, 'experienceAssetIds') ? undefined : json['experienceAssetIds'],
    };
}

export function TaskInstanceViewToJSON(value?: TaskInstanceView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'title': value.title,
        'subheading': value.subheading,
        'instructions': value.instructions,
        'assetIds': value.assetIds === undefined ? undefined : value.assetIds,
        'assets': value.assets === undefined ? undefined : ((value.assets as Array<any>).map(TaskViewAssetToJSON)),
        'milestones': value.milestones === undefined ? undefined : ((value.milestones as Array<any>).map(MilestoneToJSON)),
        'experienceName': value.experienceName,
        'robloxGameId': value.robloxGameId,
        'experienceAssetIds': value.experienceAssetIds === undefined ? undefined : value.experienceAssetIds,
    };
}

